











import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
// import { State, Action } from 'vuex-class'

import CurrencyExchangeTradeHelperComponents1MainPage from './service-for-currency-exchange-trade-helper-components/currency-exchange-trade-helper-components-1-main-page.vue'
import App4PageNotFound from '../../../html-components-type-1-basic/basic-type-1-app/app-4-page-not-found.vue'

// const namespace = 'digitalCurrency'

@Component({
  components: {
    CurrencyExchangeTradeHelperComponents1MainPage,
    App4PageNotFound
  }
})
class CurrencyExchangeTrade1 extends Vue {

  // @Action('getDigitalCurrencyTransactionById', { namespace }) getDigitalCurrencyTransactionById?: any

  currencyExchangeTradeId: string = ''

  show404Message: boolean = false

  @Watch('$route.params.currencyExchangeTradeId') async updateRouteValue () {
    await this.initializeCurrencyExchangeTrade()
  }

  async mounted () {
    await this.initializeCurrencyExchangeTrade()
  }

  async initializeCurrencyExchangeTrade () {
    this.show404Message = false
    const currencyExchangeTradeId = this.$router.currentRoute.params.currencyExchangeTradeId

    console.log('currencyExchangeTradeId: ', currencyExchangeTradeId)
    // const digitalCurrencyTransaction = null // await this.getDigitalCurrencyTransactionById(transactionId)

    // if (!digitalCurrencyTransaction || !digitalCurrencyTransaction.transactionId) {
    //   this.show404Message = true
    //   return
    // }

    // this.transactionId = digitalCurrencyTransaction.transactionId
  }
}

export default CurrencyExchangeTrade1


